import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "rounded-md bg-red-50 p-4 text-left mt-3" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = { class: "ml-3" }
const _hoisted_9 = { class: "text-sm font-medium text-red-800" }
const _hoisted_10 = { class: "mt-3 flex flex-col gap-y-4" }
const _hoisted_11 = { class: "text-left uppercase" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "text-left uppercase" }
const _hoisted_14 = { class: "text-left uppercase" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "text-left uppercase" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "text-left uppercase" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "text-left uppercase" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "text-left uppercase" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "text-left" }
const _hoisted_25 = { class: "mt-5 sm:mt-6 text-center" }

import { translate } from "@/utils/tools";
import { computed, inject, onMounted, ref, watch } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from "@headlessui/vue";
import { XCircleIcon } from "@heroicons/vue/solid";
import DropdownComponent from "../tools/DropdownComponent.vue";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'SubEventEdit',
  props: { form: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form", "edited"],
  setup(__props, { emit }) {

const props = __props


const store = useStore();
const axios = inject("$axios") as AxiosInstance;

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const selectedProvider = ref({ label: "-Select Reward Type-", value: null });
const dataProvider: any = ref([]);
const errorMessage = ref("");
const hasError = ref(false);

const fetchPageData = async () => {
  const payload = {
    operatorId: store.state.selectedOperator.operatorId,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/game/internal/provider`;
  return await axios.post(url, payload).then(({ data }) =>
    data.result.map((row: any) => ({
      label: row.providerCode,
      value: row.providerCode,
    }))
  );
};

const onUpdate = async () => {
  // console.log("sub event form onUpdate: ", props.form);

  props.form.config[0].target_settle_amount = props.form.target_settle_amount;
  props.form.config[0].target_settle_count = props.form.target_settle_count;
  props.form.config[0].target_valid_amount = props.form.target_valid_amount;
  props.form.config[0].target_round_count = props.form.target_round_count;
  await axios
    .post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/sub-events/update`,
      props.form as any,
      {
        headers: {
          "x-cm-operator-id": store.state.selectedOperator.operatorId,
        },
      }
    )
    .then((data) => {
      emit("edited");
      showSync.value = false;
    })
    .catch((err) => {
      errorMessage.value = "Sub Event นี้ถูกใช้งานไปแล้ว ไม่สามารถแก้ไขได้";
      hasError.value = true;
      showSync.value = true;
    });
  // console.log("sub event form onUpdate2: ", props.form);
};

const onProviderSelected = (e: any) => {
  selectedProvider.value = e;
  emit("update:form", { ...props.form, providers: e.value });
};

const onClose = () => {
  showSync.value = false;
  errorMessage.value = "";
  hasError.value = false;
};

watch(showSync, async (val) => {
  if (val) {
    selectedProvider.value = {
      label: props.form?.providers,
      value: props.form?.providers,
    };

    errorMessage.value = "";
    hasError.value = false;

    dataProvider.value = await fetchPageData();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[9] || (_cache[9] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.event.editSubEvent")), 1)
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_unref(XCircleIcon), {
                                class: "h-5 w-5 text-red-400",
                                "aria-hidden": "true"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("h3", _hoisted_9, _toDisplayString(errorMessage.value), 1)
                            ])
                          ])
                        ], 512), [
                          [_vShow, hasError.value]
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("messages.event.subName")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.name) = $event)),
                              class: "rounded w-full",
                              placeholder: _ctx.$t('messages.event.subName')
                            }, null, 8, _hoisted_12), [
                              [_vModelText, __props.form.name]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("messages.event.providerName")), 1),
                            _createVNode(DropdownComponent, {
                              class: "w-full",
                              options: dataProvider.value,
                              modelValue: selectedProvider.value,
                              onOnOptionSelected: onProviderSelected
                            }, null, 8, ["options", "modelValue"])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("messages.event.description")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.form.description) = $event)),
                              class: "rounded w-full",
                              placeholder: _ctx.$t('messages.event.description')
                            }, null, 8, _hoisted_15), [
                              [_vModelText, __props.form.description]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("messages.event.targetSettleAmount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "rounded w-full",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.form.target_settle_amount) = $event)),
                              min: "0",
                              placeholder: _ctx.$t('messages.event.targetSettleAmount')
                            }, null, 8, _hoisted_17), [
                              [_vModelText, __props.form.target_settle_amount]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("messages.event.targetSettleCount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "rounded w-full",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.form.target_settle_count) = $event)),
                              min: "0",
                              placeholder: _ctx.$t('messages.event.targetSettleCount')
                            }, null, 8, _hoisted_19), [
                              [_vModelText, __props.form.target_settle_count]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("messages.event.targetValidAmount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (((__props.form as any).target_valid_amount) = $event)),
                              min: "0",
                              placeholder: _ctx.$t('messages.event.targetValidAmount')
                            }, null, 8, _hoisted_21), [
                              [_vModelText, (__props.form as any).target_valid_amount]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("messages.event.targetRoundCount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (((__props.form as any).target_round_count) = $event)),
                              min: "0",
                              placeholder: _ctx.$t('messages.event.targetRoundCount')
                            }, null, 8, _hoisted_23), [
                              [_vModelText, (__props.form as any).target_round_count]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.reward.active")) + " ", 1),
                            _createVNode(_unref(Switch), {
                              modelValue: __props.form.is_active,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((__props.form.is_active) = $event)),
                              class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", __props.form.is_active ? 'bg-blue-400' : 'bg-red-500'])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass([__props.form.is_active ? 'translate-x-6' : 'translate-x-1', "inline-block h-4 w-4 transform rounded-full bg-white"])
                                }, null, 2)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "class"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (onClose())),
                        class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.event.close")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (onUpdate())),
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.event.submit")), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})